import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule, PopoverController } from '@ionic/angular';
import moment from 'moment';

import { DatetimePickerModule } from '../datetime-picker/datetime-picker.module';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, RouterModule, DatetimePickerModule],
  selector: 'app-snooze',
  templateUrl: './snooze.component.html',
  styleUrls: ['./snooze.component.scss'],
})
export class SnoozeComponent {
  isCustom = false;
  snoozeDate: any;
  showLaterToday = false;

  constructor(private popoverController: PopoverController) {
    this.snoozeDate = moment().add(1, 'day');
    const now = new Date();
    if (now.getHours() < 18) {
      this.showLaterToday = true;
    }
  }

  snoozeLaterToday() {
    this.snoozeDate = moment().startOf('day').add(18, 'hours');
    this.confirmSnooze();
  }

  snoozeTomorrow() {
    this.snoozeDate = moment().add(1, 'day').startOf('day').add(9, 'hours');
    this.confirmSnooze();
  }

  snoozeOneHour() {
    this.snoozeDate = moment().add(1, 'hour');
    this.confirmSnooze();
  }

  snooze20Minutes() {
    this.snoozeDate = moment().add(20, 'minutes');
    this.confirmSnooze();
  }

  snoozeNextWeek() {
    this.snoozeDate = moment().add(1, 'week').startOf('week').add(1, 'day').add(9, 'hours');
    this.confirmSnooze();
  }

  snoozeTwoWeeks() {
    this.snoozeDate = moment().add(2, 'weeks').startOf('week').add(1, 'day').add(9, 'hours');
    this.confirmSnooze();
  }

  snoozeNextMonth() {
    this.snoozeDate = moment().add(1, 'month').startOf('day').add(9, 'hours');
    this.confirmSnooze();
  }

  snoozeTwoMonths() {
    this.snoozeDate = moment().add(2, 'month').startOf('day').add(9, 'hours');
    this.confirmSnooze();
  }

  getInitialDate() {
    return this.snoozeDate.format('YYYY-MM-DD');
  }

  getInitialTime() {
    return this.snoozeDate.format('HH:mm');
  }

  setSnoozeDate([date, time]) {
    this.snoozeDate = moment(`${date} ${time}`);
  }

  confirmSnooze() {
    this.popoverController.dismiss({ snoozeDate: this.snoozeDate });
  }
}
